// extracted by mini-css-extract-plugin
export default {"container":"section-youtube-video_container__w9iBF","videoWrapper":"section-youtube-video_videoWrapper__-YioL"};